export { default } from './ForecastHeaderDetails';
